export enum FilterCategory {
  CuratorTypes = 'influencer_kind',
  Genres = 'subgenre',
  Countries = 'country',
  Interactions = 'interaction',
  Advanced = 'advanced',
}
